import { IDeleteManutencaoUseCase } from "../../../presentation/useCases/delete/delete_manutencao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteManutencaoUseCase
 */

export class DeleteManutencaoUseCase implements IDeleteManutencaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(idManutencao: number): Promise<void> {
    await this.repository.deleteManutencao(idManutencao);

  }
}
